import React from 'react';
import './AboutIntro.css';
import aboutImage1 from '../../assets/images/about-image-1.jpg'; // Updated image import
import aboutImage2 from '../../assets/images/about-image-2.jpg'; // Updated image import

const AboutIntro = () => {
  return (
    <section className="about-intro-section">
      <div className="container">
        <div className="about-intro-grid">
          <div className="about-intro-images">
            <img
              src={aboutImage1} // Using the specified image
              alt="Our team working" // You might want to update this alt text based on the actual image content
              className="about-image-1"
            />
            <img
              src={aboutImage2} // Using the specified image
              alt="Modern office space" // You might want to update this alt text based on the actual image content
              className="about-image-2"
            />
          </div>
          <div className="about-intro-text">
            <h2 className="about-intro-title">AI, creating limitless opportunities.</h2>
            <p>
              Neuroverse delivers cutting-edge SAP ERP solutions for growth-focused companies, aligning our services precisely with our clients’ business objectives. Our greatest asset is our team of experienced, client-focused professionals who bring deep domain expertise and extensive SAP knowledge to every project.
            </p>
            <div className="about-intro-features">
              <div className="feature-item">
                <h3>SAP CONSULTING</h3>
                <p>Empowering businesses with tailored SAP solutions for streamlined processes and sustainable growth.</p>
              </div>
              <div className="feature-item">
                <h3>AI / ML</h3>
                <p>Transforming possibilities into reality with advanced AI and ML solutions.</p>
              </div>
              <div className="feature-item">
               <h3>STAFF AUGMENTATION</h3>
                <p>Boosting your workforce with top talent through seamless staff augmentation solutions.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutIntro;